'use client';

import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { isTomsVendingContext } from '@/constants/business-units';

/** Toms Vending–only screens (e.g. vending machines placeholder). */
export function RequireTomsVending() {
  const { user } = useAuth();

  if (!isTomsVendingContext(user)) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <Outlet />;
}
